import React, { useEffect } from "react";

import { Card, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../../Message";
import Loader from "../../Loader";
import { getEventById } from "../../../actions/eventActions";

// Registration for the 2026 convention is closed: every ticket sold out, so
// the page no longer offers anything to select. What used to be the form -
// the sponsorship and registration options, their quantities and participant
// names, the extra contribution, the order summary and the PayPal/Zelle
// payment step - is replaced by the notice below. The header, the event info
// and the hotel reservation line still render: the homepage badge links
// straight here, and someone arriving that way should read the notice on the
// page they expected rather than on a bare screen. Nothing is submitted from
// here any more, and the endpoint refuses a post from a tab that still holds
// the old form on its own (see the 12024 branch in
// backend/controllers/eventController.js).
//
// Reopening registration is a revert of the commit that closed it; the form
// is unchanged in history.
const SOLD_OUT_NOTICE = "All tickets are sold out. Registration is closed.";

const CentralEventRegistration2026 = ({ match }) => {
  const { id } = match.params;

  const dispatch = useDispatch();

  const eventById = useSelector((state) => state.eventById);
  const { loading, error, event } = eventById;

  useEffect(() => {
    dispatch(getEventById(id));
  }, [dispatch, id]);

  return (
    <Container className="py-3">
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : event ? (
        <>
          {/* Page header */}
          <Card border="info" className="mb-3 shadow-sm">
            <Card.Body className="text-center py-3">
              <h4 className="text-info mb-1">{event.eventName}</h4>
              <div className="text-muted">Detroit · September 25–27, 2026</div>
            </Card.Body>
          </Card>

          {/* Sold out - stands where the registration form used to be, in the
              same card styling as the header above. */}
          <Card border="danger" className="mb-3 shadow-sm">
            <Card.Body className="text-center py-3">
              <h5 className="text-danger mb-0">{SOLD_OUT_NOTICE}</h5>
            </Card.Body>
          </Card>

          {/* Hotel reservation - external booking site, opens in a new tab.
              Hotel name comes from the event's address in the DB. */}
          <Card className="mb-3">
            <Card.Body className="py-2">
              For hotel reservation please visit:{" "}
              <a
                href="https://book.passkey.com/event/51280258/owner/437/home"
                target="_blank"
                rel="noopener noreferrer"
              >
                {event.eventAddress}
              </a>
            </Card.Body>
          </Card>
        </>
      ) : null}
    </Container>
  );
};

export default CentralEventRegistration2026;
